





















































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import $Api from '@api'
import { translate } from '@/utils/filters'
import { PaymentType, Bank, Merchant, Channel } from '@/api/model/channel'

@Component
export default class MerchantDialog extends BaseDialog {
    form = {
        merchantId: '',
        channelId: '',
        status: '',
        id: '',
        paymentType: '',
        thirdMerchantNo: ''
    }
    banks: Bank[] = []
    channels: Channel[] = []
    paymentTypes: PaymentType[] = []
    merchants: Merchant[] = []
    rules = {
        channelId: { required: true, message: translate('channel.NoNull'), trigger: 'change' },
        merchantId: { required: true, message: translate('channel.merchantNoNull'), trigger: 'change' },
        status: { required: true, message: translate('notice.StatusNoNull'), trigger: 'change' },
        paymentType: { required: true, message: translate('payType.NoNull'), trigger: 'change' },
        thirdMerchantNo: { required: true, message: translate('channel.merchantNoNull'), trigger: 'change' }
    }

    async loadData() {
        $Api.channelService.queryChannelDropdown().subscribe(data => {
            this.channels = data
        })
        $Api.channelService.queryMerchantDropdown().subscribe(data => {
            this.merchants = data
        })
        $Api.channelService.queryPaymentTypeList().subscribe(data => {
            this.paymentTypes = data
        })
    }

    create() {
        return $Api.channelService.merchantManageAdd(this.form)
    }

    update() {
        return $Api.channelService.merchantManageUpdate(this.form)
    }

    onOpen() {
        this.loadData()
    }

    onClose() {

    }
}
